export const unitsWrapperStyles = {
  overflowX: 'auto',
};

export const unitFieldsTitleWrapperStyles = {
  margin: 0,
  padding: '10px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderBottom: 'none',
  borderRadius: '4px 4px 0 0',
};

export const unitFieldsBodyWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  padding: '24px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '0 0 4px 4px',
};
